import { Constructor } from "../Extensions";
import { IControl } from "./Controls/Control";
import { ControlRef } from "./Controls/ControlRef";
import { ElementRef } from "./ElementRef";
import { JsxFragment } from "./JsxFragment";
import { NAMESPACE } from "./_Namespace";

export class JsxElement extends JsxFragment
{
    public static override classNamespace = NAMESPACE + "JsxElement";
    public static override className = "JsxElement";

    attributes?: { [key: string]: any };
    controlConstructor?: Constructor<IControl>;
    data?: any;
    events?: { [key: string]: Function };
    nodeName?: string;
    ref?: ControlRef | ElementRef;
}